export const BASEPATH = '/covid-heatmap';
export const isDevelopmentEnv = process.env.NODE_ENV == 'development';
